import React from "react";
import {
  Box,
  Typography,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Container,
  Divider,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PublicLayout from "../../layouts/PublicLayout";

const tosContent = [
  {
    title: "1. Corporate Identity & Acceptance",
    detail: "These Terms of Service govern the use of the TPOS Platform, owned and operated by ABNScripts Technologies Pvt. Ltd., having its registered office at SR NO.18, ROYAL 18, FLAT NO.201, 19/1/6, Pimpri Colony, Pimpri-Chinchwad, Maharashtra 411018. By using our software or hardware, you agree to these legally binding terms under the Information Technology Act, 2000."
  },
  {
    title: "2. Merchant Onboarding & KYC",
    detail: "In accordance with RBI Master Directions, all Merchants must undergo a 'Know Your Merchant' (KYM) process. You must provide valid PAN, GSTIN, and Bank details. We reserve the right to suspend accounts if KYC documents are found to be inaccurate or expired."
  },
  {
    title: "3. Software License & Restrictions",
    detail: "We grant you a non-exclusive, non-transferable license to use TPOS. You are strictly prohibited from reverse-engineering the software, attempting to access the source code, or using the platform for any illegal trade or money laundering activities."
  },
  {
    title: "4. Payment Settlements",
    detail: "All digital payments are routed through RBI-compliant Nodal/Escrow accounts. Standard settlement cycles are T+2 business days. ABNScripts Technologies Pvt. Ltd. acts as a technology service provider and is not liable for bank-side delays or network failures."
  },
  {
    title: "5. Jurisdiction & Dispute Resolution",
    detail: "These terms are governed by the laws of India. Any disputes arising out of the use of TPOS shall be subject to the exclusive jurisdiction of the courts located in Pune, Maharashtra."
  }
];

export default function TermsOfServices() {
  return (
    <PublicLayout>
      <Box sx={{ bgcolor: "#f9fafb", pt: 10, pb: 10 }}>
        <Container maxWidth="md">
          <Typography variant="h3" sx={{ fontWeight: 800, mb: 2, textAlign: 'center' }}>
            Terms of Service
          </Typography>
          <Typography variant="h6" color="text.secondary" sx={{ mb: 6, textAlign: 'center' }}>
            Please read these terms carefully before using the TPOS platform.
          </Typography>

          <Paper elevation={0} sx={{ p: 4, borderRadius: 3, border: "1px solid #eee" }}>
            {tosContent.map((item, index) => (
              <Accordion key={index} elevation={0} sx={{ '&:before': { display: 'none' }, borderBottom: '1px solid #eee' }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="h6" sx={{ fontWeight: 700 }}>{item.title}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography color="text.secondary" sx={{ lineHeight: 1.8 }}>
                    {item.detail}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </Paper>
        </Container>
      </Box>
    </PublicLayout>
  );
}